import {
    BANK_SUBLEDGER_BALANCE_FAILURE,
    BANK_SUBLEDGER_BALANCE_REQUEST, BANK_SUBLEDGER_BALANCE_SUCCESS,
    COUNT_BENEFICIARY_VA_FAILURE,
    COUNT_BENEFICIARY_VA_REQUEST,
    COUNT_BENEFICIARY_VA_SUCCESS,
    CUSTOMERTRANSACTION_FAILURE,
    CUSTOMERTRANSACTION_REQUEST,
    CUSTOMERTRANSACTION_SUCCESS,
    FX_RATE_REF_FAILURE,
    FX_RATE_REF_REQ,
    FX_RATE_REF_SUCCESS,
    FX_RATE_REF_SUCCESS_REGULAR,
    MASTERBALANCE_FAILURE,
    MASTERBALANCE_REQUEST,
    MASTERBALANCE_SUCCESS, RIPPLE_BALANCE_FAILURE, RIPPLE_BALANCE_REQUEST, RIPPLE_BALANCE_SUCCESS,
    VIRTUALACCOUNTSUBACCOUNTBALANCE_FAILURE,
    VIRTUALACCOUNTSUBACCOUNTBALANCE_REQUEST,
    VIRTUALACCOUNTSUBACCOUNTBALANCE_SUCCESS
} from "./dashboardType";

const initialState = {
    loading: false,
    masterBalance: {},
    subAccountBalance: {},
    virtualAccountSubAccountBalance: [],
    customerTransactions: [],
    fxRateRef:[],
    fxRateRefRegular:[],
    error: "",
    countBeneVAOfCustomer:0
};
  
const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case MASTERBALANCE_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }
    
        case MASTERBALANCE_SUCCESS: {
            return {
                ...state,
                loading: false,
                masterBalance: action.payload,
                error: "",
            };
        }
    
        case MASTERBALANCE_FAILURE: {
            return {
                ...state,
                loading: false,
                masterBalance: null,
                error: action.payload,
            };
        }

        case VIRTUALACCOUNTSUBACCOUNTBALANCE_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }
    
        case VIRTUALACCOUNTSUBACCOUNTBALANCE_SUCCESS: {
            return {
                ...state,
                loading: false,
                virtualAccountSubAccountBalance: action.payload,
                error: "",
            };
        }
    
        case VIRTUALACCOUNTSUBACCOUNTBALANCE_FAILURE: {
            return {
                ...state,
                loading: false,
                virtualAccountSubAccountBalance: null,
                error: action.payload,
            };
        }

        case CUSTOMERTRANSACTION_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }
    
        case CUSTOMERTRANSACTION_SUCCESS: {
            return {
                ...state,
                loading: false,
                customerTransactions: action.payload,
                error: "",
            };
        }
    
        case CUSTOMERTRANSACTION_FAILURE: {
            return {
                ...state,
                loading: false,
                customerTransactions: null,
                error: action.payload,
            };
        }

        case FX_RATE_REF_REQ: {
            return {
                ...state,
                loading: true
            };
        }

        case FX_RATE_REF_SUCCESS: {
            return {
                ...state,
                loading: false,
                fxRateRef: action.payload
            };
        }

        case FX_RATE_REF_SUCCESS_REGULAR: {
            return {
                ...state,
                loading: false,
                fxRateRefRegular: action.payload
            };
        }

        case FX_RATE_REF_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        case COUNT_BENEFICIARY_VA_REQUEST:{
            return {
                ...state,
                loading:true
            }
        }

        case COUNT_BENEFICIARY_VA_SUCCESS:{

            return {
                ...state,
                loading:false,
                countBeneVAOfCustomer: action.payload,
                error:''
            }
        }

        case COUNT_BENEFICIARY_VA_FAILURE:{
            return {
                ...state,
                loading:false,
                countBeneVAOfCustomer: null,
                error:action.payload
            }
        }

        case BANK_SUBLEDGER_BALANCE_REQUEST:{
            return {
                ...state,
                loading:true
            }
        }

        case BANK_SUBLEDGER_BALANCE_SUCCESS:{

            return {
                ...state,
                loading:false,
                bankSubledgerBalance: action.payload,
                error:''
            }
        }

        case BANK_SUBLEDGER_BALANCE_FAILURE:{
            return {
                ...state,
                loading:false,
                bankSubledgerBalance: null,
                error:action.payload
            }
        }

        case RIPPLE_BALANCE_REQUEST:{
            return {
                ...state,
                loading:true
            }
        }

        case RIPPLE_BALANCE_SUCCESS:{

            return {
                ...state,
                loading:false,
                rippleBalance: action.payload,
                error:''
            }
        }

        case RIPPLE_BALANCE_FAILURE:{
            return {
                ...state,
                loading:false,
                rippleBalance: null,
                error:action.payload
            }
        }

        default:
        return state;
    }
};

export default dashboardReducer;
  